import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import GlobalButton from "../button";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const tableStyle = {
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: "primary.moonGlow",
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      padding: "6px 16px",
      color: "secondary.dark",
      fontSize: "0.8rem",
    },

  "& .MuiTableCell-root .MuiTypography-body1 ": {
    fontSize: "0.875rem",
  },
};

export default function PaginatedTable({
  tableStyleProps,
  tableWidth,
  minWidth,
  tableHeader,
  tableData,
  displayRows,
  showPagination = true,
  handleViewTarrifDescription,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(-1);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer sx={{ ...tableStyle, ...tableStyleProps }}>
      <Table
        sx={{
          width: tableWidth ? tableWidth : "100%",
          minWidth: minWidth ? minWidth : "900px",
        }}
      >
        <TableHead>
          <TableRow>
            {tableHeader?.map((header) => (
              <TableCell
                key={header.id}
                sx={{ textAlign: header.align || "start" }}
              >
                {header.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? tableData?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
              )
            : tableData
          )?.map((row, index) => {
            return (
              <React.Fragment key={index}>
                <TableRow>
                  {displayRows.map((val) => {
                    return (
                      <React.Fragment key={val}>
                        {val === "idAscending" ? (
                          <TableCell>{index + 1}</TableCell>
                        ) : val === "high_price" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row.highPrice}
                          </TableCell>
                        ) : val === "price_length12" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row.length12}
                          </TableCell>
                        ) : val === "price_length18" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row.length18}
                          </TableCell>
                        ) : val === "price_length24" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row.length24}
                          </TableCell>
                        ) : val === "price_length36" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row.length36}
                          </TableCell>
                        ) : val === "tariff_description" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            <GlobalButton
                              variant="custom_gradient"
                              title="See More"
                              startIcon={
                                <VisibilityOutlinedIcon
                                  sx={{
                                    color: "#FFFFFF",
                                    cursor: "pointer",
                                  }}
                                />
                              }
                              style={{
                                width: { xs: "100%", sm: 120 },
                                padding: "5px",
                                borderRadius: "100px",
                              }}
                              handleClickBtn={() =>
                                handleViewTarrifDescription(row)
                              }
                            />
                          </TableCell>
                        ) : val === "end_date_count" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row.contractEndDateCount}
                          </TableCell>
                        ) : val === "rp_total_signed_contract" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.totalSignedContracts}
                          </TableCell>
                        ) : val === "report_total_signed_contract_saver" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.totalSaverContracts}
                          </TableCell>
                        ) : val === "report_total_signed_contract_upgrade" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.totalUpgradeContracts}
                          </TableCell>
                        ) : val === "rp_total_live_sales" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.totalLiveSale}
                          </TableCell>
                        ) : val === "rp_gp_in_rework" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.gpInRework}
                          </TableCell>
                        ) : val === "rp_gp_sales_lost" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.salesLost}
                          </TableCell>
                        ) : val === "report_gpSold" ? (
                          <TableCell
                            sx={{ textAlign: "center" }}
                          >{`£${row?.totalProfit}`}</TableCell>
                        ) : val === "report_gpInProvisioning" ? (
                          <TableCell
                            sx={{ textAlign: "center" }}
                          >{`£${row?.gpInProvisioning}`}</TableCell>
                        ) : val === "report_gpInProvisioning" ? (
                          <TableCell
                            sx={{ textAlign: "center" }}
                          >{`£${row?.gpInProvisioning}`}</TableCell>
                        ) : val === "report_gpLoss" ? (
                          <TableCell
                            sx={{ textAlign: "center" }}
                          >{`£${row?.gpLoss}`}</TableCell>
                        ) : val === "report_totalNetProfit" ? (
                          <TableCell
                            sx={{ textAlign: "center" }}
                          >{`£${row?.totalNetProfit}`}</TableCell>
                        ) : val === "report_mtd" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.mtdSold}
                          </TableCell>
                        ) : val === "report_mtdLive" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.mtdLive}
                          </TableCell>
                        ) : val === "report_max_live" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.maxLive}
                          </TableCell>
                        ) : val === "report_delayed_live" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.delayedLive}
                          </TableCell>
                        ) : val === "report_future_live" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.futureLive}
                          </TableCell>
                        ) : val === "report_sells_to_target" ? (
                          <TableCell sx={{ textAlign: "center" }}>
                            {row?.sellsToTarget}
                          </TableCell>
                        ) : val === "actions" ? (
                          <TableCell></TableCell>
                        ) : (
                          <TableCell>
                            <Typography fontSize={13} lineHeight="normal">
                              {row[val]}
                            </Typography>
                          </TableCell>
                        )}
                      </React.Fragment>
                    );
                  })}
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>

      <TablePagination
        sx={{ display: showPagination ? "block" : "none" }}
        rowsPerPageOptions={[10, 25, 50, 100, { label: "All", value: -1 }]}
        component="div"
        count={tableData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}
